import React from 'react';
import { NextPage } from 'next';
import Layout from '@sls-react/components/Layout';
import useMobile from '@sls-react/hooks/useMobile';
import TradeInMobileLander from '@sls-react/components/TradeIn/TradeInMobileLander';
import TradeInDesktopLander from '@sls-react/components/TradeIn/TradeInDesktopLander';
import { useMount } from 'react-use';
import { fireVisitedTradeInEventsPage } from '@sls-react/services/analytics/events/tradeIn';

export const EVENT_DETAILS = [
  {
    where: ['Monkey Sports', '1962 Barranca Pkwy', 'Irvine, CA 92606'],
    when: 'Sat Feb 5 10am - 6pm, Sun Feb 6 10am - 5pm',
  },
  {
    where: [
      "Dick's Sporting Goods",
      '700 Richland Blvd Ste A',
      'Prosper, TX 75078',
    ],
    when: 'Sat/Sun Feb 12/13 (10am - 6pm)',
  },
  {
    where: [
      "Dick's Sporting Goods",
      '700 Richland Blvd Ste A',
      'Prosper, TX 75078',
    ],
    when: 'Sat/Sun Feb 19/20 (10am - 6pm)',
  },
  {
    where: ["Dick's Sporting Goods", '9358 N Central Expy', 'Dallas, TX 95231'],
    when: 'Sat/Sun Feb 26/27 (10am - 6pm)',
  },
  {
    where: ['Monkey Sports', '949 Providence Hwy', 'Norwood, MA 02062'],
    when: 'Sat March 5 10am - 6pm, Sun March 6 10am - 5pm',
  },
  {
    where: [
      "Dick's Sporting Goods",
      '1300 Nixon Dr',
      'Mt. Laurel Twnshp, NJ 08054',
    ],
    when: 'Sat/Sun March 12/13 (10am - 6pm)',
  },
  {
    where: [
      "Dick's Sporting Goods",
      '1300 Nixon Dr',
      'Mt. Laurel Twnshp, NJ 08054',
    ],
    when: 'Sat/Sun March 19/20 (10am - 6pm)',
  },
  {
    where: ['Monkey Sports', '105 W Bethany Dr', 'Allen, TX 75013'],
    when: 'Sat March 26 10am - 6pm, Sun March 27 10am - 5pm',
  },
  {
    where: ["Dick's Sporting Goods", '5200 S 76th St', 'Greendale, WI 53129'],
    when: 'Sat/Sun April 2/3 (10am - 6pm)',
  },
  {
    where: ["Dick's Sporting Goods", '5200 S 76th St', 'Greendale, WI 53129'],
    when: 'Sat/Sun April 9/10 (10am - 6pm)',
  },
  {
    where: [
      "Perani's Hockey",
      '8301 Market Exchange Dr',
      'Westerville, OH 43081',
    ],
    when: 'Sat/Sun April 23/24 (10am - 5pm)',
  },
  {
    where: ["Perani's Hockey", '7325 E 96th St f', 'Indianapolis, IN 46250'],
    when: 'Sat April 30 - Sun May 1 (10am - 5pm)',
  },
  {
    where: ["Perani's Hockey", '3600 S Dort Hwy', 'Flint, MI 48507'],
    when: 'Sat/Sun May 7/8 (10am - 5pm)',
  },
  {
    where: [
      "Perani's Hockey",
      '37150 Van Dyke Ave',
      'Sterling Heights, MI 48312',
    ],
    when: 'Sat/Sun May 14/15 (10am - 5pm)',
  },
  {
    where: [
      "Perani's Hockey",
      '2101 Greentree Rd Suite B-201',
      'Pittsburgh, PA 15220',
    ],
    when: 'Sat/Sun May 21/22 (10am - 5pm)',
  },
  {
    where: ["Perani's Hockey", '19330 Middlebelt Rd', 'Livonia, MI 48152'],
    when: 'Sat/Sun Jul 14/16 (10am - 5pm)',
  },
  {
    where: [
      "Perani's Hockey",
      '8301 Market Exchange Dr',
      'Westerville, OH 43081',
    ],
    when: 'Sat/Sun Jul 23/24 (10am - 5pm)',
  },
  {
    where: [
      "Perani's Hockey",
      '5264 Hickory Hollow Pkwy',
      'Nashville, TN 37013',
    ],
    when: 'Sat/Sun Sept 10/11 (10am - 5pm)',
  },
];

interface Props {}

const TradeInEvents: NextPage<Props> = () => {
  const mobile = useMobile();
  useMount(fireVisitedTradeInEventsPage);
  return (
    <Layout title="Trade-in Events" container={false}>
      {mobile ? <TradeInMobileLander /> : <TradeInDesktopLander />}
    </Layout>
  );
};

export default TradeInEvents;
